import { FC } from 'react'
import { Container, Box } from '@maas-components/core'
import { ReactComponent as ImgError } from 'assets/images/alert_error.svg'
import { ReactComponent as ImgInfo } from 'assets/images/alert_info.svg'
import { ReactComponent as ImgSuccess } from 'assets/images/alert_success.svg'
import { ReactComponent as ImgWarning } from 'assets/images/alert_warning.svg'
import { ReactComponent as ImgEmpty } from 'assets/images/icn_empty.svg'
import { ReactComponent as ImgLock } from 'assets/images/icn_lock.svg'
import { ReactComponent as ImgExclamation } from 'assets/images/icn_warning.svg'
import Center from 'components/Center'
import { Typography } from 'components/Typography'

const statusMap = {
  success: <ImgSuccess />,
  error: <ImgError />,
  info: <ImgInfo />,
  warning: <ImgWarning />,
  404: <ImgEmpty />,
  500: <ImgExclamation />,
  403: <ImgLock />,
}

type TResultProps = {
  image?: React.ReactNode
  status: 'success' | 'error' | 'info' | 'warning' | '404' | '403' | '500'
  subtitle: string
  title: string
}

const Result: FC<TResultProps> = props => {
  const { title, subtitle, image, status, children } = props

  return (
    <Container maxWidth="xs">
      <Center>
        <Box py={2}>{image ?? statusMap[status]}</Box>
        <Typography align="center" variant="subtitle1">
          {title}
        </Typography>
        <Typography align="center" variant="body1" gutterBottom>
          {subtitle}
        </Typography>
        <Box py={2}>{children}</Box>
      </Center>
    </Container>
  )
}

export default Result
